import { SVGProps } from "react"

export const CreditCardIcon: React.FC<SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      className="stroke-fg-1"
      {...props}>
      <path
        d="M18.6667 8.33366H2M9.5 11.667H5.33333M2 6.83366L2 13.167C2 14.1004 2 14.5671 2.18166 14.9236C2.34144 15.2372 2.59641 15.4922 2.91002 15.652C3.26654 15.8337 3.73325 15.8337 4.66667 15.8337L16 15.8337C16.9334 15.8337 17.4001 15.8337 17.7567 15.652C18.0703 15.4922 18.3252 15.2372 18.485 14.9236C18.6667 14.5671 18.6667 14.1004 18.6667 13.167V6.83366C18.6667 5.90024 18.6667 5.43353 18.485 5.07701C18.3252 4.76341 18.0703 4.50844 17.7567 4.34865C17.4001 4.16699 16.9334 4.16699 16 4.16699L4.66667 4.16699C3.73325 4.16699 3.26654 4.16699 2.91002 4.34865C2.59641 4.50844 2.34145 4.7634 2.18166 5.07701C2 5.43353 2 5.90024 2 6.83366Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
